import { render, staticRenderFns } from "./roomType.vue?vue&type=template&id=b4266bfa&scoped=true"
import script from "./roomType.vue?vue&type=script&lang=js"
export * from "./roomType.vue?vue&type=script&lang=js"
import style0 from "./roomType.vue?vue&type=style&index=0&id=b4266bfa&prod&lang=scss&scoped=true"
import style1 from "./roomType.vue?vue&type=style&index=1&id=b4266bfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4266bfa",
  null
  
)

export default component.exports